<template>
    <div>

        <el-card>
            <div slot='header'>
                <el-button
                    v-for="item in typeList"
                    :key="item.default"
                    :type='item.default === isSelect ? "primary": "" '
                    @click="selectType(item.default)"
                    class="topButton">
                    {{item.cname}}
                </el-button>
            </div>

            <el-table v-if='old_params.length' :data='dataList' class='auditTable'>

                <el-table-column label="参数名" prop='key' width='200'></el-table-column>

                <el-table-column label="参数值">

                    <template slot-scope='{ row }'>

                        <vue-code-diff :old-string="row.oldStr" :new-string="row.newStr" :context="100"></vue-code-diff>

                    </template>

                </el-table-column>
            </el-table>

            <el-table v-else :data='dataList' class='auditTable'>

                <el-table-column label="参数名" prop='key' width='200'></el-table-column>

                <el-table-column label="参数值" prop='value'>
                    <template slot-scope='{ row }'>
                        <a-fold :valueStr='row.value'></a-fold>
                    </template>
                </el-table-column>
            </el-table>

            <el-form>
                <el-row>
                    <el-col :span='12'>
                        <el-form-item>
                            <el-radio-group v-model="radio">
                                <el-radio :label="1">通过</el-radio>
                                <el-radio :label="2">不通过</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                    <el-col :span='12'>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">确定</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>

        </el-card>

    </div>
</template>

<script>
    import services from './appcenter.services'
    import vueCodeDiff from 'vue-code-diff'
    import AFold from '../common/aFold'
    import { constants } from 'fs';

    export default {
        components: { vueCodeDiff, AFold },

        props: {
            app_id: String | Number,
            ind: Number,
            callback: Function,
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            env() {
                return this.dictionary.env
            }
        },

        data() {
            return {
                radio: 1,
                typeList: [],
                index: 0,
                dataList: [],
                old_params: [],
                new_params: [],
                isSelect: ''
            }
        },

        mounted() {
            this.request()
        },

        methods: {
            request() {
                services.getApproval({ id: this.app_id})
                    .then(res => {
                        this.new_params = res.new_params
                        this.old_params = res.old_params
                        this.gettypeList(res.new_params, res.old_params)
                        this.selectType(this.new_params[0].envId)
                    })
                    .catch(err => this.$message.error(err.message))
            },

            // 更改数据
            unData() {
                this.dataList = []
                if (!this.old_params.length) {
                    let newParamsList = this.new_params.filter(item => item.envId === this.index)[0].param

                    newParamsList.forEach(item => {
                        this.dataList.push(item)
                    })
                } else {
                    let newParamsList = this.new_params.filter(item => item.envId === this.index)[0] ?this.new_params.filter(item => item.envId === this.index)[0].param : []
                    let oldParamsList = this.old_params.filter(item => item.envId === this.index)[0] ? this.old_params.filter(item => item.envId === this.index)[0].param: []

                    let allParamsList = this.distinct(newParamsList.concat(oldParamsList), 'key')
                    allParamsList.forEach(item => {
                        let newParams = newParamsList.filter(i => i.key === item.key)[0]
                        let oldParams = oldParamsList.filter(i => i.key === item.key)[0]
                        this.dataList.push({
                            key: item.cname,
                            newStr: JSON.stringify(newParams),
                            oldStr: JSON.stringify(oldParams)
                        })
                    })
                }
            },

            // 切换数据
            selectType(index) {
                this.index = index
                let arr = this.typeList.filter(item => item.default === this.index)
                this.isSelect = arr[0] && arr[0].default | 0
                this.unData()
            },

            // 获取按钮列表
            gettypeList(newList, oldList) {
                let Arr = newList.concat(oldList)
                Arr = this.distinct(Arr)
                this.typeList = []
                // console.log(this.env);
                this.env.forEach(item => {
                    Arr.forEach(i => {
                        if (item.default === i.envId) {
                            this.typeList.push(item)
                        }
                    })
                })
            },

            // 去重
            distinct(array, type='envId'){
                let temp = []; //一个新的临时数组
                for(let i = 0; i < array.length; i++){
                    for(let j = i + 1; j < array.length; j++) {
                        if (array[i][type] == array[j][type]) {
                            i++
                            j = i
                        }
                    }
                    temp.push(array[i])
                }
                return temp;
            },

            // 提交审核
            onSubmit() {
                let params = {
                    app_id: this.app_id,
                    approval: this.radio
                }
                services.v1Approval(params)
                    .then(res => this.$message.success(res.message))
                    .catch(err => this.$message.error(err.message))
                    .finally(() => {
                        this.callback(this.ind)
                        this.$modal.close()
                    })
            }
        }
    }
</script>

<style lang='scss' scoped>
    .auditTable {
        #app {
            min-width: 0;

        }
    }
    .el-form {
        margin-top: 20px;
    }
    .el-col {
        display:flex;
        justify-content: center;
    }
</style>
